(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youy-banner-campanha"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('youy-campanha-slider')) {
    class YouyCampanhaSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.youy-campanha__track');
        this.dots = Array.from(this.querySelectorAll('.youy-campanha__dot'));
        this.slides = Array.from(this.querySelectorAll('.youy-campanha__slide'));
        if (!this.track || this.slides.length < 2) return;
        this.index = 0;
        this.delay = parseInt(this.dataset.autoplay || '0', 10);
        this.dots.forEach((dot) => dot.addEventListener('click', () => { this.go(parseInt(dot.dataset.index, 10)); this.restart(); }));
        this.track.addEventListener('scroll', () => {
          window.clearTimeout(this._s);
          this._s = window.setTimeout(() => this.sync(), 80);
        }, { passive: true });
        ['mouseenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => this.stop(), { passive: true }));
        ['mouseleave', 'focusout', 'touchend'].forEach((ev) => this.addEventListener(ev, () => this.restart(), { passive: true }));
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.restart()));
        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            const i = this.slides.findIndex((s) => s.contains(e.target) || s === e.target);
            if (i > -1) { this.stop(); this.go(i); }
          });
        }
        this.restart();
      }
      disconnectedCallback() { this.stop(); }
      go(i) {
        const n = this.slides.length;
        this.index = ((i % n) + n) % n;
        this.track.scrollTo({ left: this.slides[this.index].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.mark();
      }
      sync() {
        const w = this.track.clientWidth || 1;
        this.index = Math.round(this.track.scrollLeft / w);
        this.mark();
      }
      mark() {
        this.dots.forEach((d, k) => d.setAttribute('aria-selected', k === this.index ? 'true' : 'false'));
      }
      stop() { window.clearInterval(this._t); this._t = null; }
      restart() {
        this.stop();
        if (this.delay > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this._t = window.setInterval(() => this.go(this.index + 1), this.delay);
        }
      }
    }
    customElements.define('youy-campanha-slider', YouyCampanhaSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youy-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('youy-video')) {
    customElements.define('youy-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.btn = this.querySelector('.youy-vd__sound');
        this.mq = window.matchMedia('(max-width: 749px)');
        this.pick = () => {
          const mobile = this.mq.matches && this.dataset.mobile;
          const src = mobile ? this.dataset.mobile : (this.dataset.desktop || this.dataset.mobile);
          const poster = mobile ? this.dataset.posterMobile : this.dataset.posterDesktop;
          if (poster) this.video.poster = poster;
          if (src && this.video.getAttribute('src') !== src) {
            this.video.setAttribute('src', src);
            if (this.visible) this.play();
          }
        };
        this.mq.addEventListener('change', this.pick);
        this.pick();
        this.btn.addEventListener('click', () => {
          const on = this.video.muted;
          this.video.muted = !on;
          this.btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          this.btn.setAttribute('aria-label', on ? 'Desativar som' : 'Ativar som');
          if (on) this.play();
        });
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            this.visible = e.isIntersecting;
            if (e.isIntersecting) { this.play(); } else { this.video.pause(); }
          });
        }, { threshold: 0.25 });
        this.io.observe(this);
      }
      play() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches && this.video.muted) return;
        const p = this.video.play();
        if (p && p.catch) p.catch(() => {});
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); if (this.mq) this.mq.removeEventListener('change', this.pick); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
